// extracted by mini-css-extract-plugin
module.exports = {"error":"style_error__2mTbs","success":"style_success__QP6Wb","info":"style_info__1_9nx","left":"style_left__xWlHv","center":"style_center__3aOMj","right":"style_right__3m6pG"};